// Shared between the client (SpamGuardFields, formToken) and the server (helpers/forms/spamGuard.server).

// Honeypot: a hidden field real users never fill. Bots that fill every field trip it.
export const HONEYPOT_FIELD = 'website';

// Server-signed token carrying the time it was issued. Every submission to a form
// API must carry one, so bots that post straight to the API are rejected.
export const FORM_TOKEN_FIELD = 'formToken';

// Tokens younger than this are rejected: no human fills a form that fast.
export const MIN_FILL_MS = 3000;

// Tokens older than this are rejected, so a captured request can't be replayed forever.
export const FORM_TOKEN_MAX_AGE_MS = 24 * 60 * 60 * 1000;
